export default __webpack_public_path__ + "static/media/rsvp.b54a2c25.gif";